// extracted by mini-css-extract-plugin
export default {"style":"style___ig3mR","title":"title___hTKQE","title2":"title2___oyfjF","tip":"tip___hmfzD","url":"url___xMfeg","link":"link___hhgdY"};